import React from 'react';
import {
  hourOfDay,
  formatClock,
  timeOfDayLabel,
  timeOfDayIcon,
} from './three/dayNightCycle';

/**
 * Compact date + clock HUD shown over the 3D facility view. Reads the sim clock
 * (state.tick / gameDay / gameWeek) — purely presentational, no dispatch.
 * Positioned top-left so it never collides with the right-side RoomDrawer.
 */
export function CalendarBadge({ state }) {
  const tick = state?.tick ?? 0;
  const day = state?.gameDay ?? 1;
  const week = state?.gameWeek ?? 1;
  const hour = hourOfDay(tick);
  const isNight = timeOfDayIcon(hour) === '🌙';

  return (
    <div
      style={{
        position: 'absolute',
        top: 14,
        left: 14,
        zIndex: 5,
        pointerEvents: 'none',
        userSelect: 'none',
        padding: '8px 14px',
        borderRadius: 12,
        background: isNight
          ? 'linear-gradient(135deg, rgba(16,22,40,0.82), rgba(28,36,62,0.82))'
          : 'linear-gradient(135deg, rgba(34,48,72,0.78), rgba(52,74,108,0.78))',
        border: '1px solid rgba(255,255,255,0.14)',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        boxShadow: '0 4px 16px rgba(0,0,0,0.28)',
        color: '#eef2fb',
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        lineHeight: 1.25,
        minWidth: 150,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          fontWeight: 700,
          fontSize: 14,
          letterSpacing: 0.2,
        }}
      >
        <span style={{ fontSize: 16 }}>{timeOfDayIcon(hour)}</span>
        <span>Day {day}</span>
        <span style={{ opacity: 0.5 }}>·</span>
        <span style={{ opacity: 0.85 }}>Week {week}</span>
      </div>
      <div
        style={{
          marginTop: 2,
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          fontSize: 12,
          opacity: 0.85,
        }}
      >
        <span style={{ fontVariantNumeric: 'tabular-nums', fontWeight: 600 }}>
          {formatClock(hour)}
        </span>
        <span style={{ opacity: 0.6 }}>{timeOfDayLabel(hour)}</span>
      </div>
    </div>
  );
}
